import {Component, Input, OnInit} from "@angular/core";

import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FormsModule} from "@angular/forms";
import {IconDefinition} from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'outline-button',
  imports: [FontAwesomeModule, FormsModule],
  templateUrl: './outline-button.html',
  standalone: true,
  styleUrls: ['./outline-button.component.css']
})
export class OutlineButtonComponent implements OnInit {
  @Input('marginRight') marginRight: boolean = false
  @Input('text') text: string = ''
  @Input('customClass') class: string = `text-align: center; border-width: 1px; border-color: ${localStorage.getItem('primaryColor')}; margin-right: 8px; border-radius: 0.5rem; padding: 0.50rem 0.75rem; color: ${localStorage.getItem('primaryColor')};`
  @Input('disabledClass') disabledClass: string = 'border border-gray-400 rounded-lg mr-[8px] text-gray-400 py-2 px-3 text-center'
  @Input('faIcon') faIcon:  IconDefinition | null = null
  @Input('disabled') disabled: boolean = false
  @Input('addToClass') addToClass: string = ''
  @Input('IconRight') IconRight: boolean = false
  @Input('fullWidth') fullWidth: boolean = false

  ngOnInit() {
    if(this.marginRight)
      this.class += ` margin-right: 0.50rem;`
    if(this.addToClass !== '')
      this.class += ' ' + this.addToClass
    if(this.fullWidth) {
      this.disabledClass += ' w-full'
      this.class += ' width: 100%;'
    }
  }
}
